import useABTestValue from '@hooks/useABTestValue'

export type UseShowBlinkerAndLoudspeaker = () => ReturnType<
  typeof useABTestValue<'showBlinkerAndLoudspeaker'>
>

const useShowBlinkerAndLoudspeaker: UseShowBlinkerAndLoudspeaker = () =>
  useABTestValue('showBlinkerAndLoudspeaker')

export default useShowBlinkerAndLoudspeaker
